query CurrentUser {
  currentUser {
    id
    email
    phone
    firstName
    lastName
    displayName
    avatar {
      id
      url(format: SMALL)
    }
    isAdmin
    isSuperAdmin
  }
}
